import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { TeaserBoxLink } from '../../../shared/teaser-box/teaser-box.component'
import { ConvertedComponentData, Image, TextInput } from '../../../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'
import { CmsLinkType } from '../../../../enums/cms-link-type'

@Injectable({ providedIn: 'root' })
export class TeaserBoxHomepageImageConverter extends CmsConverterService<TeaserBoxHomepageImageData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const link = formData.st_link?.value?.formData ?? {}
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      lazyLoadImage: formData.st_lazy_load_image?.value ?? false,
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
      text: formData.st_text ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      link: {
        ...formData.st_link ?? defaultLinkData,
        text: link.lt_text?.value ?? '',
        name: formData.st_link?.name ?? '',
        uid: formData.st_link?.uid || CmsLinkType.CONTENT_LINK,
      },
      promotionTracking: formData.st_promotion_tracking?.value?.identifier ?? true
    }
  }
}

export const TEASER_BOX_HOMEPAGE_IMAGE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserBoxHomepageImageData>>(
  'TeaserBoxHomepageImageConverter')

export interface TeaserBoxHomepageImageData extends ConvertedComponentData {
  text: TextInput;
  headline: TextInput;
  fsCatalogIndex?: number;
  image: Image;
  link: TeaserBoxLink;
  lazyLoadImage: boolean;
  promotionTracking: boolean;
}
